import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Visit, Problems } from 'src/app/services/interfaces/interfaces';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

interface TipoContacto {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-edit-visit',
  templateUrl: './edit-visit.component.html',
  styleUrls: ['./edit-visit.component.scss']
})
export class EditVisitComponent implements OnInit {

  form: FormGroup;

  tipoContactos: TipoContacto[] = [
    { value: 'presencial', viewValue: 'Presencial' },
    { value: 'mail', viewValue: 'Email' },
    { value: 'telefono', viewValue: 'Telefono' }
  ];

  problems_sell: Problems[] = [
    {
      nombre: 'tiene stock',
      value: {
        ID: 0,
        ttdesc: '',
        pvta_codigo: "0",
        pvta_tipo: "pvta",
        'ven-cod': 7
      }
    },
    {
      nombre: 'paso pedido',
      value: {
        ID: 1,
        ttdesc: '',
        pvta_codigo: "1",
        pvta_tipo: "pvta",
        'ven-cod': 7,
      }
    },
    {
      nombre: 'sin necesidad',
      value: {
        ID: 2,
        ttdesc: '',
        pvta_codigo: "2",
        pvta_tipo: "pvta",
        'ven-cod': 7,
      }
    },
    {
      nombre: 'precio',
      value: {
        ID: 3,
        ttdesc: '',
        pvta_codigo: "3",
        pvta_tipo: "pvta",
        'ven-cod': 7,
      }
    },
    {
      nombre: 'diferente calidad o servicio',
      value: {
        ID: 4,
        ttdesc: '',
        pvta_codigo: "4",
        pvta_tipo: "pvta",
        'ven-cod': 7,
      }
    },
    {
      nombre: 'plazo entrega',
      value: {
        ID: 5,
        ttdesc: '',
        pvta_codigo: "5",
        pvta_tipo: "pvta",
        'ven-cod': 7,
      }
    },
    {
      nombre: 'modalidad competencia',
      value: {
        ID: 6,
        ttdesc: '',
        pvta_codigo: "6",
        pvta_tipo: "pvta",
        'ven-cod': 7,
      }
    },
    {
      nombre: 'no esta comprando',
      value: {
        ID: 7,
        ttdesc: '',
        pvta_codigo: "7",
        pvta_tipo: "pcob",
        'ven-cod': 7,
      }
    }
  ];

  problemas_cob: Problems[] = [
    {
      nombre: 'no debe',
      value: {
        ID: 1,
        ttdesc: '',
        pvta_codigo: "0",
        pvta_tipo: "pcob",
        'ven-cod': 7
      }
    },
    {
      nombre: 'giraron',
      value: {
        ID: 2,
        ttdesc: '',
        pvta_codigo: "1",
        pvta_tipo: "pcob",
        'ven-cod': 7
      }
    },
    {
      nombre: 'sin preparar',
      value: {
        ID: 3,
        ttdesc: '',
        pvta_codigo: "2",
        pvta_tipo: "pcob",
        'ven-cod': 7
      }
    },
    {
      nombre: 'sin disponibilidad',
      value: {
        ID: 4,
        ttdesc: '',
        pvta_codigo: "3",
        pvta_tipo: "pcob",
        'ven-cod': 7
      }
    },
    {
      nombre: 'giraran',
      value: {
        ID: 5,
        ttdesc: '',
        pvta_codigo: "1",
        pvta_tipo: "pcob",
        'ven-cod': 7
      }
    }
  ];

  constructor(
    private dialog: MatDialog,
    private builder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public visit: Visit
  ) { }

  ngOnInit() {
    this.form = this.builder.group({
      'cli-cod': ['', Validators.required],
      'ven-cod': [''],
      vis_tipoContacto: [''],
      cli_nombre: [''],
      vis_fecha: [''],
      vis_CotizTipo: [''],
      vis_otrosDatos: [''],
      vis_otrosDatos1: [''],
      vis_venta: [''],
      vis_cobranza: [''],
      vis_cargaUsu: [''],
      vis_comentarios: [''],
      ttproblemas: [[]]
    });
    console.log(this.visit);
  }

  leave(): void {
    this.dialog.closeAll();
  }

}
